module.exports = __webpack_public_path__ + "img/icon_problem1@2x.382bc6d7.png";